import {React, observer, classNames, pluralize, Fragment, Popover2} from '@api'
import {Button, Icon, Menu, MenuDivider, MenuItem, Popover} from '@blueprintjs/core'
import {Tooltip2} from '@api'
import * as css from './CatalogSelectionToolbarMenu.css'
import { icons } from '@stores/ui'
import {ContextMenuItem, useStores } from '@design-board'

export const SelectedCatalogItemsActionMenuItems = observer(function SelectedCatalogItemsActionMenuItems() {
  const stores = useStores()

  if (stores.isGlobalStore) return null

  const {
      strings, catalog: {
        dialogs,
        onPublishSelectedItems, canCreateItem, clearSelection, isActionButtonEnabled, catalogItemName, settings: {viewMode, levelOfDetail},
        selection: {allowDuplicate, allowDelete, selectedItemCount, offlineSelectedIds, offlineValidSelectedIds, toggleSelectedInlineDetails, showFreezeMenuButton, freezeSelectedIds, selected_toggleActive, selected_setAllActive, selected_setAllInactive, selected_refreshImages},
        features: {actionButtons},
      }
    } = stores,
    itemNamePluralized = pluralize(catalogItemName, selectedItemCount),
    createBtn = isActionButtonEnabled('create'),
    deleteBtn = isActionButtonEnabled('delete'),
    duplicateBtn = isActionButtonEnabled('duplicate'),
    toggleActive = isActionButtonEnabled('toggleActive')

  return <Fragment>
    {showFreezeMenuButton === true && <MenuItem icon={'filter'} text={strings.filterFromSelection} label={`(${selectedItemCount.toString()})`} onClick={freezeSelectedIds}/>}
    <ContextMenuItem text={strings.clearSelection} icon='clean' label={`(${selectedItemCount.toString()})`} onClick={clearSelection}/>
    {levelOfDetail === 0 &&
     <Fragment>
	     <MenuDivider/>
       <ContextMenuItem
        className={classNames({'bp3-disabled': viewMode === "table"})}
        text={strings.toggleInlineDetails} icon='zoom-in' onClick={toggleSelectedInlineDetails}/>
     </Fragment>}
    {selectedItemCount > 0 && canCreateItem && <Fragment>
	    <MenuDivider/>
	    <Tooltip2 content={strings.validPublishCountTitle(offlineValidSelectedIds?.length, offlineSelectedIds.length)} placement='bottom'>
		    <ContextMenuItem text={strings.uploadToC8}
		              className={classNames({'bp3-disabled': offlineSelectedIds?.length == 0 || offlineValidSelectedIds?.length !== offlineSelectedIds.length})}
		              icon={icons.publish} label={strings.validPublishCount(offlineValidSelectedIds?.length, offlineSelectedIds.length)}
		              onClick={onPublishSelectedItems}>
		    </ContextMenuItem>
	    </Tooltip2>
    </Fragment>}

    {toggleActive && <MenuItem text={`Toggle Active`} icon='exchange' shouldDismissPopover={false} onClick={selected_toggleActive}
              children={selectedItemCount > 1 ?
     <Fragment>
       <MenuItem text='Set all Active' shouldDismissPopover={false} icon='tick-circle' onClick={selected_setAllActive}/>
       <MenuItem text='Set all Inactive' shouldDismissPopover={false} icon='disable' onClick={selected_setAllInactive}/>
     </Fragment> : undefined} />}


    {duplicateBtn && <Fragment>
	    <MenuDivider/>
	    <ContextMenuItem
		    text={`Duplicate ${itemNamePluralized}`}
		    icon={icons.duplicate}
		    disabled={!allowDuplicate}
		    onClick={() => dialogs.showConfirmationProductPopup(
              {message: `Are you sure you want to duplicate ${selectedItemCount == 1 ? `this ${catalogItemName}` : `these ${selectedItemCount.toLocaleString()} ${catalogItemName}s`}?`, operation: 'DUPLICATE_PRODUCTS'})
            }/>
    </Fragment>}
    {(deleteBtn || (selectedItemCount == offlineSelectedIds.length)) &&
     <ContextMenuItem
	     text={`Delete ${itemNamePluralized}`} icon='trash'
	     disabled={!allowDelete}
	     onClick={() => dialogs.showConfirmationProductPopup(
           {
             message: `Are you sure you want to delete ${selectedItemCount == 1 ? `this ${_.toLower(catalogItemName)}` :
                                                         `these ${selectedItemCount.toLocaleString()} ${catalogItemName}s`}?`,
             operation: 'DELETE_PRODUCTS'
           })}/>}

    {actionButtons?.extraSelectionMenuItems &&
     <Fragment>
	     <MenuDivider/>
       {actionButtons.extraSelectionMenuItems.map(({icon, text, label, onClick}, i) =>
         !text ? <MenuDivider key={i}/> : <MenuItem key={i} icon={icon} text={text} label={label} onClick={() => onClick(stores)}/>)}
     </Fragment>}

    {selectedItemCount > 0 && 
      <Fragment>
      <MenuDivider/>
      <MenuItem text='Refresh Images' shouldDismissPopover={false} icon='image-rotate-right' onClick={selected_refreshImages}/>
    </Fragment>
    }
  </Fragment>
})

export const CatalogSelectionToolbarMenu = observer(function CatalogSelectionToolbarMenu( ) {
  const stores = useStores()

  if (stores.isGlobalStore) return null

  const {
    catalog: {
      selection: {selectedItemCount, selectedItemsLabel}, isProductView
    },
    isGlobalStore
  } = stores

  return isGlobalStore ? null : (selectedItemCount > 0 || !isProductView) &&
         <div className={css.buttons}>
           {selectedItemCount > 0 &&
            <Popover2 minimal
                      interactionKind='hover'
                      position='bottom'
                      content={
             <Menu className={css.popoverMenu}>
             <SelectedCatalogItemsActionMenuItems />
           </Menu>}>
		       <Button minimal
		               rightIcon='caret-down' text={selectedItemsLabel}/>
	       </Popover2>
           }
         </div>

})


// WEBPACK FOOTER //
// ./src/modules/catalog/internal/topBar/components/CatalogSelectionToolbarMenu.tsx